import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import reveal from './directives/reveal'
import '@/assets/styles/theme.scss'

Vue.config.productionTip = false
Vue.directive('reveal', reveal)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
